import { useEffect, useState } from 'react';

import { createRoot } from 'react-dom/client';
import '../assets/css/drawer.css';
import '../assets/css/styles.css';
import separador from '../assets/img/separador.png';
import header from '../assets/img/casas.png';
import Drawer from '../components/drawer.jsx'
import Dialog from '../components/dialog2.jsx'
import _Dialog from '../components/dialog.jsx'
import { getCopa } from '../funciones/sesion.js'
import { casaIc } from '../funciones/casas.js'
import r from '../assets/img/casas/r.png';
import g from '../assets/img/casas/g.png';
import h from '../assets/img/casas/h.png';
import s from '../assets/img/casas/s.png';
import { clubMensaje, copaMensaje } from '../funciones/generales.js'
import { typeWriter } from '../funciones/typeWriter';
var fR = 0;
var fH = 0;
var fG = 0;
var fS = 0;
var total = 0;


function Copa(props) {
    const [Pr, setPr] = useState(0);
    const [Pg, setPg] = useState(0);
    const [Ph, setPh] = useState(0);
    const [Ps, setPs] = useState(0);

    const [nom, setNom] = useState([]);
    const [casa, setCasa] = useState([]);
    const [pts, setPts] = useState([]);


    function club() {
        createRoot(document.getElementById("dg")).render(<Dialog />)

        setTimeout(() => {
            const elemento = document.getElementById('mensaje');
            typeWriter(elemento, clubMensaje(), 100, function () {
                createRoot(document.getElementById("dg")).unmount(<Dialog />)
            })
        }, 200);
    }

    function copa() {
        createRoot(document.getElementById("dg")).render(<_Dialog />)
        setTimeout(() => {
            const elemento = document.getElementById('mensaje');
            typeWriter(elemento, copaMensaje(), 100, function () {
                createRoot(document.getElementById("dg")).unmount(<_Dialog />)
            })
        }, 200);

    }

    function ObtenerCopa() {
        copa();
        const elements = document.getElementsByClassName('element');
        
        getCopa().then(data => {
            total = 0;
            console.log(data)
            data.puntos.forEach((element) => {
                switch (element.casa) {
                    case "Slytherin":
                        fS = element.puntos;
                        break;
                    case "Hufflepuff":
                        fH = element.puntos;
                        break;
                    case "Gryffindor":
                        fG = element.puntos;
                        break;
                    case "Ravenclaw":
                        fR = element.puntos;
                        break;
                }
                total = parseInt(total) + parseInt(element.puntos)
                console.log("totAL", total)
            });

            let $fG = (fG / total) * 100;
            let $fS = (fS / total) * 100;
            let $fR = (fR / total) * 100;
            let $fH = (fH / total) * 100;

            setPr(fR);
            setPg(fG);
            setPh(fH);
            setPs(fS);

            document.getElementsByClassName("grad-g")[0].style.background = "linear-gradient(.06turn, #740001 0%, #740001 " + $fG + "%, #f0f0f0 " + $fG + "%, #f0f0f0 100%)"
            document.getElementsByClassName("grad-s")[0].style.background = "linear-gradient(.06turn, #2A623D 0%, #2A623D " + $fS + "%, #f0f0f0 " + $fS + "%, #f0f0f0 100%)"
            document.getElementsByClassName("grad-h")[0].style.background = "linear-gradient(.06turn, #CD9C27 0%, #CD9C27 " + $fH + "%, #f0f0f0 " + $fH + "%, #f0f0f0 100%)"
            document.getElementsByClassName("grad-r")[0].style.background = "linear-gradient(.06turn, #0E1A40 0%, #0E1A40 " + $fR + "%, #f0f0f0 " + $fR + "%, #f0f0f0 100%)"
            setNom([]);
            setCasa([]);
            setPts([]);

            data.top.forEach((element) => {
                setNom(oldArray => [...oldArray, element.nombre]);
                setPts(oldArray => [...oldArray, element.pts]);
                setCasa(oldArray => [...oldArray, casaIc(element.casa)]);

            });

        });
    }


    useEffect(() => {

        ObtenerCopa();
       
    }, []);
    return (
        <div className="Sesion">
            <header>

            </header>

            
            <div id="dg"></div>
            <div class="container-">
                <div class="banderines">
                    <img src={header} class="img-responsive "></img>
                </div>
                <div class="padding">
                    <p class="titulo-copa">¡La gran copa de las casas!</p>
                </div>
                <div class="padding">
                    <p class="cuerpo-copa">Participa en la gran copa de las casas patrocinada especialmente por la escoba encantada, gana puntos en cada consumo y recibe una sorpresa al final de cada cuatrimestre. </p>
                    <p class="cuerpo-copa">¡La casa con más puntos será la ganadora!.</p>
                </div>
                <div class="padding separador center-v-">
                    <img src={separador} class="img-responsive" />
                </div>
                <div class="padding">
                    <div class="row">
                        <div class="col center-v-">
                            <img src={r} class="img-responsive ic-casa"></img>
                            <div class="bar-p grad-r"></div>
                            <div class="pts"><p>{Pr} pts.</p></div>
                        </div>
                        <div class="col center-v-">
                            <img src={g} class="img-responsive ic-casa"></img>
                            <div class="bar-p grad-g"></div>
                            <div class="pts"><p>{Pg} pts.</p></div>
                        </div>
                        <div class="col center-v-">
                            <img src={h} class="img-responsive ic-casa"></img>
                            <div class="bar-p grad-h"></div>
                            <div class="pts"><p>{Ph} pts.</p></div>
                        </div>
                        <div class="col center-v-">
                            <img src={s} class="img-responsive ic-casa"></img>
                            <div class="bar-p grad-s"></div>
                            <div class="pts"><p>{Ps} pts.</p></div>
                        </div>
                    </div>
                </div>
                <div class="padding top-buffer">
                    <p class="titulo-copa">Pertenece al club de las eminencias de La Escoba Encantada</p>
                    <p style={{ textAlign: "end", fontSize: 12 }} onClick={club}>Más información...</p>
                </div>
                <div class="padding separador center-v-">
                    <img src={separador} class="img-responsive" />
                </div>
                <div class="padding">
                    <div class="row center-v bottom-buffer">
                        <div class="col-1"><p>#1</p></div>
                        <div class="col-2"><p><img src={casa[0]} class="img-resposnive ic-casa"></img></p></div>
                        <div class="col-9 club"><p>{nom[0]} - {pts[0]}pts.</p></div>
                    </div>
                    <div class="row center-v bottom-buffer">
                        <div class="col-1"><p>#2</p></div>
                        <div class="col-2"><p><img src={casa[1]} class="img-resposnive ic-casa"></img></p></div>
                        <div class="col-9 club"><p>{nom[1]} - {pts[1]}pts.</p></div>
                    </div>
                    <div class="row center-v bottom-buffer">
                        <div class="col-1"><p>#3</p></div>
                        <div class="col-2"><p><img src={casa[2]} class="img-resposnive ic-casa"></img></p></div>
                        <div class="col-9 club"><p>{nom[2]} - {pts[2]}pts.</p></div>
                    </div>
                </div>
            </div>



        </div>);
}

export default Copa;